import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Actions, ofActionCompleted, ofActionSuccessful, Store } from '@ngxs/store';
import { Router } from '@angular/router';
import { AuthSelectors } from '@shared/store/auth/auth.selectors';
import { ConversationsActions } from 'app/view/conversations/store/conversations/conversations.actions';
import { NotificationsApiService } from 'app/view/notifications/services/notifications-api.service';
import { NotificationsActions } from 'app/view/notifications/store/notifications.actions';
import { merge, Subject, takeUntil } from 'rxjs';
import { ApplicationModel } from 'app/model/application.model';
import { AuthActions } from '@shared/store/auth/auth.actions';
import { ApplicationActions } from '@shared/store/application/application.actions';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  private onDestroy$: Subject<void> = new Subject<void>();
  private interval;
  constructor(private applicationModel: ApplicationModel,
              private router: Router,
              private actions: Actions,
              private notificationsApiService: NotificationsApiService,
              private store: Store) {
    this.subscribeNotificationsStatus()
  }

  ngOnInit() {
    merge(
      this.actions.pipe(
        ofActionSuccessful(AuthActions.Login)
      ),
      this.actions.pipe(
        ofActionSuccessful(AuthActions.SetPassword)
      )
    ).pipe(
      takeUntil(this.onDestroy$)
    ).subscribe(() => this.router.navigate([ '/dashboard/list' ]));


    this.actions.pipe(
      ofActionCompleted(AuthActions.Logout),
      takeUntil(this.onDestroy$)
    ).subscribe(() => this.router.navigate([ '/auth/login' ]));

    this.actions.pipe(
      ofActionCompleted(AuthActions.GetCurrentLogged),
      takeUntil(this.onDestroy$)
    ).subscribe((user) => {
      if (user) {
        this.callForNotificationsRefresh()
      }
    });

    this.updateMenu();
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
    clearInterval(this.interval)
  }

  // HostListener doesn't work in ApplicationModel, so it's placed in a global component
  @HostListener('window:resize', [ '$event' ])
  onResize() {
    this.applicationModel.windowSize.next(window.innerWidth);
  }

  updateMenu(): void {
    this.store.dispatch(new ApplicationActions.UpdateMenu([
      { title: 'HOME', icon: 'home', link: '/dashboard', routerLinkExact: true },
      { title: 'CONSULTATIONS', icon: 'messages', link: '/consultations', routerLinkExact: true },
      { title: 'JOURNAL', icon: 'mood-edit', link: '/journal', routerLinkExact: true },
      { title: 'HEALTH_MONITOR', icon: 'clipboard-text', link: '/health-monitor', routerLinkExact: true },
      { title: 'SELF_HELP', icon: 'bulb', link: '/help/self-help', routerLinkExact: true },
      { title: 'SUPPORT', icon: 'help-hexagon', link: '/help/support', routerLinkExact: true }
    ]));
  }

  private subscribeNotificationsStatus(): void {
    this.interval = setInterval(() => {
      const user =     this.store.selectSnapshot(AuthSelectors.getCurrentLogged)
      if (user) {
        this.callForNotificationsRefresh()
      }
    }, 5 * 60 * 1000)
  }

  private callForNotificationsRefresh(): void {
    this.notificationsApiService.getNotificationsStatus().subscribe(res => {
      this.store.dispatch(new ConversationsActions.SetHasUnreadedConversation(!!res.unreadConversations?.length))
      this.store.dispatch(new NotificationsActions.setHasUnreadNotifications(!!res.unreadNotifications?.length))
    })
  }
}
